import React, { FC } from "react";

import { useLabels } from "../../../contexts/labels";
import { ProductStrip } from "./product-strip";

export interface ProductSectionProps extends Queries.ProductStripDataFragment {}

export const ProductSection: FC<ProductSectionProps> = (props) => {
  const { labels } = useLabels();

  return <ProductStrip labels={labels} {...props} />;
};
